module.exports = __webpack_public_path__ + "img/rocket.b89cec7d.png";